import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import cityPageContent from "../data/city-page-content";

/**
 * "Emergency Roof Repair In {city}" section — new in the Wyoming design
 * (Figma node 440:1511): copy on the left, office photo on the right. The
 * design's estimate/call pair above it is dropped — this section follows the
 * services grid, which already closes with "Schedule a Free Consultation".
 *
 * Driven entirely by cityPageContent, so it renders only on pages whose city and
 * service define emergencyHeading + emergencyBody, and stays absent everywhere
 * else.
 *
 * The photo is the design's "image 48" — the office frontage with two service
 * trucks. It is queried from src/images rather than referenced out of static/ so
 * gatsby-plugin-image emits WebP and a srcset; the 310 KB original is otherwise
 * shipped whole to every visitor.
 */
const CityEmergencyRepair = ({ city, service }) => {
  const { emergencyHeading, emergencyBody } = cityPageContent.forPage(city, service);
  if (!emergencyHeading || !emergencyBody) return null;

  const cityName = String(city || "").trim();

  return (
    <StaticQuery
      query={graphql`
        query {
          officeImage: file(relativePath: { eq: "roach-office-trucks.jpg" }) {
            childImageSharp {
              gatsbyImageData(width: 800)
            }
          }
        }
      `}
      render={(data) => {
        const officeImg = getImage(data.officeImage.childImageSharp);

        return (
          <section className="py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-display font-extrabold text-neutral-900 leading-tight mb-4">
                    {emergencyHeading}
                  </h2>
                  <p className="text-neutral-700 text-base leading-relaxed m-0">{emergencyBody}</p>
                </div>
                <div className="rounded-xl overflow-hidden bg-neutral-200">
                  {officeImg ? (
                    <GatsbyImage
                      image={officeImg}
                      alt={`Roach Home Improvement office and service trucks serving ${cityName}, MI`}
                      className="w-full h-full"
                    />
                  ) : null}
                </div>
              </div>
            </div>
          </section>
        );
      }}
    />
  );
};

export default CityEmergencyRepair;
